export const MapPositionIcon = ({ className }) => {
  return (
    <svg
      width="26"
      height="34"
      viewBox="0 0 26 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.27499 5.14154C6.63952 -1.64842 18.7752 -1.77896 23.2232 5.14154C31.9399 18.7037 12.8008 33.9591 12.7496 33.9999C12.7496 33.9999 -6.4538 18.7212 2.27499 5.14154ZM12.7496 6.79974C9.46366 6.79974 6.7994 9.46386 6.7994 12.7499C6.7995 16.0359 9.46372 18.7001 12.7496 18.7001C16.0352 18.6999 18.6987 16.0358 18.6988 12.7499C18.6988 9.46402 16.0353 6.8 12.7496 6.79974Z"
        fill="currentColor"
      />
    </svg>
  );
};
